import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../models/user';
import { environment } from 'src/environments/environment';


@Injectable()
export class AuthenticationService {

  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  public user: User;

  constructor(private http: HttpClient) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  login(values) {
    return this.http.post<any>(`${environment.BACKEND}security/auth/internal`, values)
    .pipe(
      map(result => {
        this.setSession(result.response);
      })
    );
  }

  loginExternal(values) {
    return this.http.post<any>(`${environment.BACKEND}security/auth/${values.name}`, values)
    .pipe(
      map(result => {
        this.setSession(result.response);
      })
    );
  }

  setSession(value) {
    if (value.signed_user && value.token) {
      localStorage.setItem('currentUser', JSON.stringify(value.signed_user));
      localStorage.setItem('currentToken', JSON.stringify(value.token));
      this.currentUserSubject.next(value.signed_user);
    }
  }

  logout(cookie) {
    this.currentUserSubject.next(null);
    return this.http.post<any>(`${environment.BACKEND}security/logout`, {
      'cookie': cookie
    }).subscribe();
  }

  isProcurator() {
    const currentUser = this.currentUserSubject.value;
    if (currentUser.idProfile !== 9) {
      return false;
    } else {
      return true;
    }
  }

  getCodigoEmail(email) {
    return this.http.post<any>(`${environment.BACKEND}notificacion/mailCodeValidation/send`, email);
  }

  getVerificationEmail(codigoValidacion) {
    return this.http.post<any>(`${environment.BACKEND}notificacion/mailCodeValidation/receive`, codigoValidacion);
  }

}
